module.exports = __webpack_public_path__ + "static/media/carousel-1.2c942e7b.jpg";